// extracted by mini-css-extract-plugin
export default {"artical":"index_artical_2X-Wu"};